<template>
  <v-card class="pa-3 ma-0">
    <v-layout row align-center justify-space-between>
      <h2>{{ $lang.header.massTranslate }}</h2>
      <v-btn
        flat
        fab
        small
        type="button"
        class="ma-0"
        data-dismiss="modal"
        @click="$emit('close')"
        aria-label="Close">
        <v-icon>close</v-icon>
      </v-btn>
    </v-layout>
    <v-alert :value="true" type="error" v-if="err">
      {{err}}
    </v-alert>
    <div>
      <v-layout row wrap align-center justify-space-between class="checkbox-wrap my-4">
        <v-select
          :label="$lang.labels.inputLanguage"
          :items="languages"
          item-text="text"
          item-value="value"
          class="pt-0 mt-2 max-w"
          v-model="inputLang"
          hide-details
        />
        <v-select
          :label="$lang.labels.outputLanguage"
          :items="languages"
          item-text="text"
          item-value="value"
          class="pt-0 mt-2 max-w"
          v-model="outputLang"
          hide-details
        />
      </v-layout>
      <v-layout row wrap align-center justify-space-between class="checkbox-wrap my-4">
        <v-flex xs12>
          <h3>{{ $lang.header.overwriteOptions }}</h3>
        </v-flex>
        <v-flex xs4 v-for="(item, index) in scope"
                :key="index">
          <v-checkbox
            color="primary"
            v-model="item.selected"
            :label="item.name">
          </v-checkbox>
        </v-flex>
      </v-layout>
      <v-layout row justify-end>
        <v-btn color="primary" class="mx-0" @click="submitTranslate()">{{ $lang.actions.submit }}</v-btn>
      </v-layout>
    </div>
  </v-card>
</template>

<script>
  export default {
    name: "MassAllItemsLanguage",
    data() {
      return {
        language: this.$cookie.get('lang') || 'en',
        languages: JSON.parse(localStorage.languages),
        inputLang: null,
        outputLang: null,
        scope: [
          { value: 'abbrevation', name: `${this.$lang.header.abbrevation} ${this.$lang.actions.overwrite}`, selected: true},
          { value: 'name', name: `${this.$lang.header.name} ${this.$lang.actions.overwrite}`, selected: true},
          { value: 'description', name: `${this.$lang.header.description} ${this.$lang.actions.overwrite}`, selected: true},
          { value: 'sizes', name: `${this.$lang.header.sizes} ${this.$lang.actions.overwrite}`, selected: true},
          { value: 'options', name: `${this.$lang.header.options} ${this.$lang.actions.overwrite}`, selected: true},
          { value: 'variants', name: `${this.$lang.header.variants} ${this.$lang.actions.overwrite}`, selected: true},
          { value: 'styles', name: `${this.$lang.header.styles} ${this.$lang.actions.overwrite}`, selected: true},
        ],
        err: '',
      }
    },
    watch: {
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
    },
    methods: {
      submitTranslate() {
        if (!this.inputLang || !this.outputLang) {
          this.err = this.$lang.errors.inputOutputLangs;
          return;
        }
        if (this.inputLang === this.outputLang) {
          this.err = this.$lang.errors.inputOutputLangsSame;
          return;
        }
        let submitObj = {};
        submitObj.scope = this.scope;
        submitObj.inputLang = this.inputLang;
        submitObj.outputLang = this.outputLang;
        this.$emit('submit', submitObj);
      },
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// MassAllItemsLanguage.vue?77f98f3a